import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Logo } from "../assets/logo.svg";
import { ReactComponent as Add } from "../assets/add.svg";
import "../styles/Header.css";
import { useNavigate } from "react-router-dom";
import { getAvatar, getUsername } from "../utils/commonFunctions";
import { storage as localStorage} from "../utils/storage";

interface HeaderProps {
  openPricing: () => void;
  remainingCredits: number;
  loading: boolean;
}

export default function Header({
  openPricing,
  remainingCredits,
  loading,
}: HeaderProps) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [username, setUsername] = useState<string | null>(null);
  const [avatar, setAvatar] = useState<React.ReactNode>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null); // Ref for the dropdown
  const userProfileRef = useRef<HTMLSpanElement | null>(null); // Ref for the user profile button

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  useEffect(() => {
      // Fetch avatar
      const fetchAvatar = async () => {
        const avatar = await getAvatar();
        setAvatar(avatar);
      };

      // Fetch username
      const fetchUsername = async () => {
        const username = await getUsername();
        setUsername(username);
      };

      fetchUsername();
      fetchAvatar();
  }, []);

  // Close the dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        userProfileRef.current &&
        !userProfileRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false); // Close dropdown if the click is outside
      }
    };

    // Add event listener for mouse clicks
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="logo-container">
        <div className="logo">
          <Logo height={50} width={"auto"} />
        </div>
      </div>
      <div className="user-info">
        <div className="user-name">
          {username}
          <span
            className="user-profile"
            ref={userProfileRef} // Attach ref to profile button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)} // Toggle dropdown on click
          >
            {avatar}
          </span>
          {isDropdownOpen && (
            <div className="user-dropdown" ref={dropdownRef}>
              {" "}
              {/* Attach ref to dropdown */}
              <button onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>
        <button className="credits-button" onClick={openPricing}>
          <div className="credits-amount">
            {loading ? "loading..." : `${remainingCredits} Minutes`}
          </div>
          <Add />
        </button>
      </div>
    </header>
  );
}
